import { decamelize } from 'humps';

// @see https://pergamin.atlassian.net/browse/PERG-2335
const doNotDecamelizeKeys = ['contractValues', 'contract_values'];

const decamelizeObject = <T = any>(data: T): T => {
  if (typeof data === 'object' && data !== null && !(data instanceof Date)) {
    return Object.entries(data as object).reduce<any>((acc, [key, value]) => {
      const ignore = doNotDecamelizeKeys.includes(key);

      return {
        ...acc,
        [decamelize(key)]: ignore ? value : decamelizeObject(value),
      };
    }, {});
  }

  return data;
};

export const parseRequestData = (data: any) => {
  if (data instanceof FormData) {
    const newData = new FormData();

    for (const [key, value] of data.entries()) {
      newData.append(decamelize(key), value);
    }

    return newData;
  }

  return decamelizeObject(data);
};
